export enum SubProcessType {
    Dynamic = "Dynamic",
    Specified = "Specified",
}